export const environment = {
  version: 'staging',
  production: true,
  url: 'https://admin-staging.sainte-maxime.favie.tech',
  apiUrl: 'https://api-staging.sainte-maxime.favie.tech',
  defaultLanguage: 'fr',
  supportedLanguages: ['en', 'fr'],
  firebase: {
    apiKey: 'AIzaSyDpOUiIDpD4F4dB9MeGlPUvXCVBtjAg8hI',
    authDomain: 'sainte-maxime-722df.firebaseapp.com',
    projectId: 'sainte-maxime-722df',
    storageBucket: 'sainte-maxime-722df.appspot.com',
    messagingSenderId: '115911394812',
    appId: '1:115911394812:web:4274787e09540cba41de79',
    measurementId: 'G-15XDHEX1R8',
  },
  fileUploadMaximumFileSize: 3145728,
};
